import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { EventObserver } from 'src/providers/event-service';
import { Contact, ContactField, Contacts, IContactField } from '@awesome-cordova-plugins/contacts/ngx';
import { isPresent } from '../../../providers/common-service';
import { Component, Renderer2 } from '@angular/core';
import { adjustViewZIndex } from '../../../globals';
import { MessageDisplayUtil } from '../../../message-display-utils';
import { PlayerInfo } from './../../../data/player-data';
import { Country } from './../../../data/country-location';
import { PlayerService } from '../../../providers/player-service/player-service';
import * as moment from 'moment';
@Component({
  templateUrl: 'new-contact.page.html',
  styleUrls: ['new-contact.page.scss'],
})
export class NewContactPage {
  public firstName: string;
  public lastName: string;
  public email: string;
  public phone: string;
  public handicap: number;
  public gender: string = "M";
  public teeOffFrom: string = "Black";
  public creating: boolean = false;
  public openedAsDialog: boolean;
  public phoneLength: number;
  public countryList: Array<Country>;
  public countryId: string = "MYS";
  public nationalityList: Array<Country>;
  public nationalityId: string = "MYS";
  public openedModal: boolean;
  public dob: any;

  constructor(private navParams: NavParams,
    private contacts: Contacts,
    private globalEventObserver: EventObserver,
    private modalCtl: ModalController,
    private platform: Platform,
    private nav: NavController,
    private renderer: Renderer2,
    private alertCtl: AlertController,
    private loadCtl: LoadingController,
    private toastCtl: ToastController,
    private playerService: PlayerService) {
    this.openedAsDialog = navParams.get("openedAsDialog");
    this.openedModal = navParams.get("openedModal");
  }

  ionViewDidEnter() {
    if (!this.openedAsDialog) {
      adjustViewZIndex(this.nav, this.renderer);
    }
    this.getCountry();
  }

  async createContact() {
    //Validate the entries

    if (!isPresent(this.firstName) || !isPresent(this.email) || !isPresent(this.lastName) || this.firstName == '' || this.lastName == '') {
      let msg = "Please enter all mandatory fields!";
      MessageDisplayUtil.displayErrorAlert(this.alertCtl, "New Contact",
        msg, "OK");
      return;
    }
    let busy = await this.loadCtl.create({
      message: "Creating contact..."
    });
    busy.present().then(() => {
      this.creating = true;
      let _dateOfBirth = null;
      if(this.dob) _dateOfBirth = moment(this.dob, "YYYY-MM-DD").format("YYYY-MM-DD");
      this.playerService.addContact(this.firstName, this.lastName,
        this.gender, this.email, this.phone, this.handicap, this.teeOffFrom, this.countryId, this.nationalityId,_dateOfBirth)
        .subscribe((player: PlayerInfo) => {
          //Player registered successfully. Go back to where came from
          busy.dismiss().then(() => {
            if (this.openedAsDialog)
              this.modalCtl.dismiss(player);
            else {
              this.globalEventObserver.getObservable().subscribe((data) => {
                if (data.chanel == "FriendListUpdate") {
                  this.nav.pop();
                }
              })
            }

          }), (error) => {
            busy.dismiss().then(() => {
              let _error = error;
              this.creating = false;
              // let msg       = MessageDisplayUtil.getErrorMessage(error, "Error creating contact");
              let msg = MessageDisplayUtil.getErrorMessage(error, _error.errorMessage);
              MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
            });

          }, () => {
            this.creating = false;
          }
        });

    })
  }

  pickAContact() {
    this.contacts.pickContact()
      .then((contact: Contact) => {
        this.firstName = contact.name.givenName;
        this.lastName = contact.name.familyName;
        if (contact.emails && contact.emails.length) {
          //Find whether preferred is set
          let emails: Array<IContactField> =
            contact.emails.filter((f: ContactField) => {
              return f.pref;
            });
          if (emails && emails.length) this.email = emails[0].value;
          else this.email = contact.emails[0].value;
        }
        else this.email = "";
        //Pick the phone number
        if (contact.phoneNumbers && contact.phoneNumbers.length) {
          this.phone = this.pickPhoneNumber(contact.phoneNumbers);
        }
        else this.phone = "";
        // alert(JSON.stringify(contact.phoneNumbers));
      }, (error) => {
        alert(JSON.stringify(error));
      });
  }

  private pickPhoneNumber(phoneNumbers: Array<IContactField>): string {
    let mobileNumbers: Array<IContactField>
      = phoneNumbers.filter((ph: ContactField) => {
        return "mobile" === ph.type.toLowerCase();
      });
    if (mobileNumbers && mobileNumbers.length === 1)
      return mobileNumbers[0].value;
    else if (mobileNumbers && mobileNumbers.length > 1) {
      let preferred = mobileNumbers.filter(m => {
        return m.pref;
      });
      if (preferred && preferred.length)
        return preferred[0].value;
      else return mobileNumbers[0].value;
    }
    else {
      //mobile numbers not found. Find other numbers
      let preferred = phoneNumbers.filter(p => {
        return p.pref
      });
      if (preferred && preferred.length)
        return preferred[0].value;
      else
        return phoneNumbers[0].value;
    }
  }

  close() {
    if (this.openedAsDialog || this.openedModal) this.modalCtl.dismiss();
  }

  getCountry() {
    this.playerService.getCountryList()
      .subscribe((data: Array<Country>) => {
        // console.log("Country Sign Up : ",data)
        this.countryList = data;
        this.nationalityList = data;
        // console.log("Country List Sign Up : ", this.countryList)
      });
  }
}
